import React, { Component } from "react";
import portrait from "../Assets/img/portrait.jpeg";
import graphics from "../Assets/img/graphics.png";
import Resume from "../Assets/kb-resume2.pdf";
import MorphingBlob from "./MorphingBlob";

class Hero extends Component {
  render() {
    return (
      <div className="hero">
        <div className="container">
          <section className="row">
            <div className="col-md-6">
              <h1>Hi, I'm Kim! 👋 </h1>
              <h3>
                I’m a product designer with front-end development experience,
                designing end-to-end digital solutions that empower users and
                impact business outcomes.
              </h3>
              <div className="row">
                <a href="mailto:synthoxide@gmail.com" class="btn-default">
                  Get in touch
                </a>

                {/* <a href={Resume} target="_blank" class="btn-secondary">
                  <span class="material-symbols-rounded">download</span>
                  Download Resume
                </a> */}
              </div>
            </div>
            <div className="col-md-6 portrait text-center">
              <MorphingBlob  image={portrait} alt="Kim's portrait" />
            </div>
          </section>
        </div>
      </div>
    );
  }
}

export default Hero;
